import { create } from 'zustand';

const useGameStore = create((set, get) => ({
  // Game state
  playerScore: 0,
  arsenalItems: [],
  selectedSlot: 0,
  showHuntAgain: false,
  
  // Chat state
  messages: ['Welcome to simple bomberman'],
  messageInput: '',
  
  // Players state
  gamePlayers: [],
  
  // Game actions
  onHuntAgain: null,
  onLeaveGame: null,
  onSendMessage: null,
  
  // Actions
  setPlayerScore: (score) => set({ playerScore: score }),
  setArsenalItems: (items) => set({ arsenalItems: items }),
  setSelectedSlot: (slot) => set({ selectedSlot: slot }),
  setShowHuntAgain: (show) => set({ showHuntAgain: show }),
  setMessages: (messages) => set({ messages: Array.isArray(messages) ? messages : [] }),
  setMessageInput: (input) => set({ messageInput: input }),
  setGamePlayers: (players) => set({ gamePlayers: players }),
  setOnHuntAgain: (callback) => set({ onHuntAgain: callback }),
  setOnLeaveGame: (callback) => set({ onLeaveGame: callback }),
  setOnSendMessage: (callback) => set({ onSendMessage: callback }),
  
  // Update multiple game data at once
  updateGameData: (data) => set((state) => ({
    ...state,
    ...data
  })),
  
  // Reset game state
  resetGameState: () => set({
    playerScore: 0,
    arsenalItems: [],
    selectedSlot: 0,
    showHuntAgain: false,
    messages: ['Welcome to simple bomberman'],
    messageInput: '',
    gamePlayers: [],
    onHuntAgain: null,
    onLeaveGame: null,
    onSendMessage: null
  })
}));

export default useGameStore;
